<div class="grid">
    <div class="col-12">
        <form [formGroup]="modelsForm">
            <p-card
                formArrayName="vehicleModels"
                [header]="'ADD_MODEL' | translate"
            >
                <div class="fex align-items-center gap-1" *ngIf="make">
                    <span class="ml-3 text-600 font-semibold text-xl"
                        >{{ "VEHICLE_MAKE" | translate }} &nbsp;</span
                    >
                    -
                    <span class="ml-2 text-600 font-semibold text-xl">{{
                        make.name
                    }}</span>
                </div>
                <p-messages [closable]="true" />
                <div
                    class="p-fluid flex align-items-end"
                    *ngFor="
                        let item of vehicleModelItems.controls;
                        let i = index
                    "
                    [formGroupName]="i"
                >
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="firstname" class="text-sm text-500">{{
                            "VEHICLE_MODEL_NAME" | translate
                        }}</label>
                        <input
                            type="text"
                            id="name"
                            [placeholder]="
                                'ENTER_VEHICLE_MODEL_NAME' | translate
                            "
                            pInputText
                            formControlName="name"
                        />
                    </div>
                    <p-button
                        class="mb-3"
                        severity="success"
                        (onClick)="addExtraModel()"
                        icon="pi pi-plus"
                        [rounded]="true"
                        [outlined]="false"
                    />
                    <p-button
                        class="mb-3 ml-1"
                        severity="danger"
                        icon="pi pi-minus"
                        [disabled]="!displayRemoveButton"
                        (onClick)="removeModelBeforeSaving(i)"
                        [rounded]="true"
                        [outlined]="false"
                    />
                </div>
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2 mt-1">
                        <p-button
                            icon="pi pi-arrow-left"
                            pRipple
                            (onClick)="backClicked()"
                            [label]="'BACK' | translate"
                            severity="secondary"
                        />

                        <button
                            icon="pi pi-check"
                            [label]="'SAVE' | translate"
                            (click)="onSubmit()"
                            severity="primary"
                            pButton
                            pRipple
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </form>
    </div>
</div>
